import React, { Component } from 'react'
import styled from 'styled-components'
import easing from 'ui/styles/easing'
import InViewMonitor from 'react-inview-monitor'

const Wrapper = styled.div`
  margin-bottom: 46px;
  position: relative;
  transform: ${props => props.inView ? 'translateY(0px)' : 'translateY(30px)'};
  opacity: ${props => props.inView ? 1 : 0};
  transition: transform 0.6s ${easing.easeOutCubic}, opacity 0.6s ${easing.easeOutCubic};
  
  a {
    color: inherit;
  }
`

const Content = styled.div`
  width: 100%;
  background: ${props => props.theme.colors.grey.lightest};
  padding: 30px;

  &:hover {
    svg {
      transform: translateX(25%);
    }
  }
`

const Title = styled.h3`
  font-size: 22px;
  color: ${props => props.theme.colors.theme.base};
`

const Text = styled.p`
  font-size: 14px;
  line-height: 19px;
  color: ${props => props.theme.colors.grey.darkest};
  max-width: 75%;
`

const Button = styled.div`
  width: 80px;
  height: 50px;
  background: ${props => props.theme.colors.theme.base};
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: transform 0.3s ${easing.easeOutCubic};
  }
`

export default class External extends Component {
  render() {
    const {
      title,
      text,
      url
    } = this.props
    
    return(
      <InViewMonitor childPropsInView={{inView: true}}>
        <Wrapper>
          <a
            href={url}
            target="_blank"
          >
            <Content>
              <Button>
                <svg
                  width="18"
                  height="15"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#FFF"
                    fillRule="evenodd"
                    d="M10.5610474 14.812003c-.1539376.1484976-.2731487.187997-.4680326.187997h-.8352535c-.349599 0-.4294185-.2414961-.194625-.4679922l6.6330485-6.3986434H.3887311C.1360559 8.1333644 0 8.0021166 0 7.7583707v-.5167414c0-.2437459.1360559-.3749937.3887311-.3749937h15.3074537L9.0631363.4679922C8.8283428.2414961 8.9081623 0 9.2580203 0h.8352535c.194884 0 .3311989.0562491.4677732.187997l7.3073674 7.0491326c.1754475.1692473.1754475.3564943 0 .5257416l-7.3073674 7.0491326 4e-7-8e-7z"
                  />
                </svg>
              </Button>
              <Title>{title}</Title>
              <Text>{text}</Text>
            </Content>
          </a>
        </Wrapper>
      </InViewMonitor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/LinkBoxes/External.js